// <ambiw-buddy> — "Delta", Ambiw's soft-body mascot. Drag, throw, poke, kick, spin.
(() => {
  if (customElements.get('ambiw-buddy')) return;
  const TAU = Math.PI * 2;
  const LINES = {
    poke: [
      { t: 'go for it!' },
      { t: 'go Shopify Plus →', link: 'services', href: 'SHOPIFY Services v2.dc.html' },
      { t: 'be happy :)' },
      { t: 'hire us on retainer →', link: 'retainer', href: 'SHOPIFY RETAINER.dc.html' },
      { t: 'your store, but faster' },
      { t: 'more checkouts, please' },
      { t: 'ship it!' },
      { t: 'I run on Liquid' },
      { t: 'conversion rate: up and up' },
      { t: "let's build something →", link: 'contact', href: '#contact' },
      { t: 'growth, compounded' },
      { t: 'boop. you found me' }
    ],
    kick: ['wheee!', 'ouch', 'hey!', 'rude.', 'woah'],
    dizzy: ['so dizzy…', '@_@', 'which way is up'],
    wake: ['oh! hi', 'was not sleeping'],
    land: ['nailed it', 'ta-da'],
    throw: ['wheee!', 'to infinity!', 'again! again!']
  };
  const pick = a => a[(Math.random() * a.length) | 0];
  const COMMON = {
    'Hero': ['welcome! scroll with me', 'wave'], 'Marquee': ['look at them go', 'look'], 'Image band': ['nice view', 'happy'],
    'Studio image': ['home sweet home', 'happy'], 'Studio banner': ['home sweet home', 'happy'], 'Case studies': ['ooh, receipts', 'point'],
    'Our way': ['calm, clear, no surprises', 'look'], 'Ways to partner': ['pick your flavour', 'look'], 'CTA': ['go on, say hi!', 'cheer']
  };
  const TOUR = {
    home: { 'Intro statement': ["that's us", 'look'], 'One platform': ['one team, start to finish', 'look'], 'Selected work': ['ooh, the good stuff', 'point'], 'What we do': ['pick a service, any service', 'look'], 'Shopify Plus': ['my favourite part', 'cheer'], 'How we build': ['look at those numbers!', 'cheer'], 'Tech partners': ['we know all of these', 'look'], 'Testimonials': ['they like us :)', 'happy'], 'Insights': ['nerd corner', 'look'] },
    about: { 'Hero': ['hi! this is us', 'wave'], 'Statement': ['we mean it', 'look'], 'Our story': ["grab a coffee, it's a good one", 'look'], 'What we stand for': ['our whole vibe', 'happy'], 'The people': ['my favourite humans', 'cheer'], 'Life at Ambiw': ['we have snacks', 'happy'], 'Join': ["psst, we're hiring", 'point'] },
    amazon: { 'Hero': ['Amazon, but make it calm', 'wave'], 'Every retainer includes': ['all of this, every month', 'look'], 'Services': ['we do the heavy lifting', 'look'], 'Why brands trust us': ['they trust us. you can too', 'happy'] },
    career: { 'Hero': ['come work with me!', 'wave'], 'Culture': ['no egos, just good work', 'happy'], 'Open roles': ['one of these is yours', 'point'], 'Perks': ['the perks are real', 'cheer'], 'Photos': ["that's the team!", 'happy'], 'CTA': ['apply, apply, apply!', 'cheer'] },
    contact: { 'Hero': ['ooh, a new friend', 'wave'], 'Contact': ['type something nice', 'point'] },
    retainer: { 'Hero': ['an always-on team', 'wave'], 'Free trial': ['try us. for free!', 'cheer'], 'A month on retainer': ["here's a typical month", 'look'], 'What hours cover': ['so many things', 'look'], 'Why a retainer': ['less hiring, more shipping', 'look'], 'How pricing works': ['no surprise invoices', 'happy'], 'FAQ': ['ask me anything. or read these', 'look'] },
    services: { 'Hero': ["let's build your store", 'wave'], 'Services': ['pick a service, any service', 'look'], 'Migration integrations': ['we move stores, carefully', 'look'], 'Shopify Plus': ['my favourite part', 'cheer'], 'How we work': ['step by step', 'look'], 'Engagements': ['find your fit', 'point'] },
    testimonials: { 'Hero': ['the nice-words page', 'wave'], 'Stats': ['look at those numbers!', 'cheer'], 'Featured quote': ['*blushes*', 'happy'], 'Reviews': ["keep reading, I don't mind", 'happy'], 'Portfolio grid': ['we made these', 'point'], 'Featured quote 2': ["stop it, you're making me blush", 'happy'], 'More reviews': ["there's more!", 'look'], 'Clients': ['our friends', 'look'] },
    work: { 'Hero': ['the good stuff lives here', 'wave'], 'Featured': ['start with this one', 'point'], 'Projects': ["scroll, there's loads", 'look'] }
  };
  const KEYS = [
    ['how an engagement runs', 'one team, start to finish', 'look'], ['selected work', 'ooh, the good stuff', 'point'],
    ['what we do', 'pick a service, any service', 'look'], ['shopify plus partner', 'my favourite part', 'cheer'],
    ['how we build', 'look at those numbers!', 'cheer'], ['stack behind', 'we know all of these', 'look'],
    ['the way we work', 'calm, clear, no surprises', 'look'], ['feedback', 'they like us :)', 'happy'],
    ['insights', 'nerd corner', 'look'], ['how we work', 'step by step', 'look'], ['ways to work together', 'find your fit', 'point'],
    ['start here', 'try us. for free!', 'cheer'], ['how it runs', "here's a typical month", 'look'],
    ['what your hours cover', 'so many things', 'look'], ['why a retainer', 'less hiring, more shipping', 'look'],
    ['how it works', 'no surprise invoices', 'happy'], ['ways to partner', 'pick your flavour', 'look'],
    ['case studies', 'ooh, receipts', 'point'], ['faq', 'ask me anything. or read these', 'look'],
    ['every retainer includes', 'all of this, every month', 'look'], ['seller central account', 'we do the heavy lifting', 'look'],
    ['why brands trust us', 'they trust us. you can too', 'happy'], ['committed to excellence', 'we mean it', 'look'],
    ['our story', "grab a coffee, it's a good one", 'look'], ['what we stand for', 'our whole vibe', 'happy'],
    ['the people', 'my favourite humans', 'cheer'], ['want to help build', "psst, we're hiring", 'point'],
    ['service required', 'type something nice', 'point'], ['project inquiry', 'type something nice', 'point'],
    ['open roles', 'one of these is yours', 'point'], ['perks', 'the perks are real', 'cheer'],
    ['careers', "psst, we're hiring", 'point'], ["let's build", 'go on, say hi!', 'cheer'], ['ready to grow', 'go on, say hi!', 'cheer'], ['talk to us', 'go on, say hi!', 'cheer']
  ];
  const BORED = ['psst… there\'s more below', 'scroll a bit?', 'hello? anyone?'];
  const CONFETTI = ['#8FC2FF', '#FFC94D', '#95E0A8', '#FF8FB1', '#B79CFF'];
  const polar = (n, f) => Array.from({ length: n }, (_, i) => { const th = (i / n) * TAU - Math.PI / 2, r = f(th); return { x: Math.cos(th) * r, y: Math.sin(th) * r }; });
  const resample = (poly, n) => {
    const seg = poly.map((p, i) => { const q = poly[(i + 1) % poly.length]; return Math.hypot(q.x - p.x, q.y - p.y); });
    const L = seg.reduce((a, b) => a + b, 0), out = [];
    let k = 0, acc = 0;
    for (let i = 0; i < n; i++) {
      const d = (i / n) * L;
      while (acc + seg[k] < d) { acc += seg[k]; k++; }
      const p = poly[k], q = poly[(k + 1) % poly.length], u = (d - acc) / seg[k];
      out.push({ x: p.x + (q.x - p.x) * u, y: p.y + (q.y - p.y) * u });
    }
    return out;
  };
  const mirror = half => { const h = half.map(([x, y]) => ({ x, y })); return h.concat(h.slice(1, -1).reverse().map(p => ({ x: -p.x, y: p.y }))); };
  const smooth = (p, k = 6) => { for (let s = 0; s < k; s++) p = p.map((q, i) => { const a = p[(i - 1 + p.length) % p.length], b = p[(i + 1) % p.length]; return { x: (a.x + 2 * q.x + b.x) / 4, y: (a.y + 2 * q.y + b.y) / 4 }; }); return p; };
  const box = (x0, y0, x1, y1) => [{ x: x0, y: y0 }, { x: x1, y: y0 }, { x: x1, y: y1 }, { x: x0, y: y1 }];
  const shape = (pts, n = 96, k = 6) => smooth(resample(pts, n), k);
  const puzzle = () => {
    const s = .66, out = [], corners = [[-s, -s], [s, -s], [s, s], [-s, s]], sign = [1, 1, -1, -1];
    for (let e = 0; e < 4; e++) {
      const A = corners[e], B = corners[(e + 1) % 4], tx = (B[0] - A[0]) / (2 * s), ty = (B[1] - A[1]) / (2 * s);
      const nx = ty * sign[e], ny = -tx * sign[e], mx = (A[0] + B[0]) / 2, my = (A[1] + B[1]) / 2;
      const r = .2, nk = .09, cx = mx + nx * .25, cy = my + ny * .25;
      out.push({ x: A[0], y: A[1] });
      const p1 = [mx - tx * nk, my - ty * nk], p2 = [mx + tx * nk, my + ty * nk];
      out.push({ x: p1[0], y: p1[1] });
      const a1 = Math.atan2(p1[1] + ny * .1 - cy, p1[0] + nx * .1 - cx), a2 = Math.atan2(p2[1] + ny * .1 - cy, p2[0] + nx * .1 - cx);
      let d = ((a2 - a1) % TAU + TAU) % TAU; const am = a1 + d / 2;
      if (Math.cos(am) * nx + Math.sin(am) * ny < 0) d -= TAU;
      for (let i = 0; i <= 16; i++) { const t = a1 + d * i / 16; out.push({ x: cx + Math.cos(t) * r, y: cy + Math.sin(t) * r }); }
      out.push({ x: p2[0], y: p2[1] });
    }
    return out;
  };
  const SHAPES = {
    cart: { color: '#FFC94D', n: 96, intro: 'added to cart!', face: { ey: -.06, ex: .26, er: .14, my: .2 }, make: () => shape([{ x: -.88, y: -.45 }, { x: .88, y: -.45 }, { x: .64, y: .45 }, { x: -.62, y: .45 }]) },
    plus: { color: '#95E0A8', n: 96, intro: 'go Shopify Plus →', link: 'services', href: 'SHOPIFY Services v2.dc.html', face: { ey: .04, ex: .27, er: .15, my: .36 }, make: () => shape([{ x: -.62, y: -.66 }, { x: .62, y: -.66 }, { x: .78, y: .8 }, { x: -.78, y: .8 }]) },
    card: { color: '#FF8FB1', n: 96, intro: 'checkout, optimized', face: { ey: -.06, ex: .26, er: .15, my: .28 }, make: () => shape(box(-1, -.62, 1, .62), 96, 8) },
    cursor: { color: '#B79CFF', n: 96, intro: 'UX/UI that converts', face: { fx: -.12, ey: -.22, ex: .14, er: .11, my: .02 }, make: () => shape([{ x: -.5, y: -1.05 }, { x: .6, y: .1 }, { x: .14, y: .14 }, { x: .4, y: .78 }, { x: .16, y: .9 }, { x: -.1, y: .26 }, { x: -.5, y: .6 }], 96, 3).map(p => ({ x: p.x * 1.15, y: p.y * 1.15 })) },
    puzzle: { color: '#6FD6E6', n: 96, intro: 'integrations: all plugged in', face: { ey: -.02, ex: .24, er: .14, my: .26 }, make: () => shape(puzzle(), 96, 0).map(p => ({ x: p.x * 1.05, y: p.y * 1.05 })) },
    parcel: { color: '#D9A066', n: 96, intro: 'Amazon, handled →', link: 'amazon', href: 'AMAZON RETAINER.dc.html', face: { ey: .08, ex: .28, er: .15, my: .4 }, make: () => shape(box(-.84, -.62, .84, .7), 96, 4) },
    calendar: { color: '#FF9E7A', n: 96, intro: 'hire us on retainer →', link: 'retainer', href: 'SHOPIFY RETAINER.dc.html', face: { ey: .12, ex: .27, er: .15, my: .46 }, make: () => shape(box(-.8, -.72, .8, .78), 96, 7) },
    delta: { color: '#8FC2FF', n: 96, intro: 'back to basics. hi!', face: { ey: .12, ex: .25, er: .15, my: .4 },
      make: () => polar(96, th => { const ph = ((th - Math.PI / 6) % (TAU / 3) + TAU) % (TAU / 3) - Math.PI / 3; return Math.min(.62 / Math.cos(ph), .62 * 1.85) * .72 + .28; }) },
    kitty: { color: '#FFB86B', n: 96, intro: 'meow! I\'m Mochi now', face: { ey: .08, ex: .34, er: .16, my: .36 },
      lines: [{ t: 'meow. go Shopify Plus →', href: 'SHOPIFY Services v2.dc.html' }, { t: 'purr-chase complete' }, { t: 'I knock carts over. not yours' }],
      make: () => polar(96, th => {
        const c = Math.cos(th), s = Math.sin(th);
        let r = 1 / Math.sqrt((c / 1.02) ** 2 + (s / .84) ** 2);
        for (const ea of [-Math.PI / 2 - .68, -Math.PI / 2 + .68]) { const d = Math.abs(Math.atan2(Math.sin(th - ea), Math.cos(th - ea))); r += .52 * Math.max(0, 1 - d / .3); }
        return r * .9;
      }) },
    leaf: { color: '#E8483B', n: 96, intro: 'Maple here, eh!', face: { ey: .02, ex: .19, er: .13, my: .24 },
      lines: [{ t: 'sorry, eh?' }, { t: 'proudly Canadian' }, { t: 'maple-syrup smooth checkout' }],
      make: () => resample(mirror([[0, -1], [.16, -.64], [.33, -.76], [.27, -.3], [.55, -.6], [.6, -.42], [.9, -.5], [.78, -.18], [.94, -.1], [.5, .24], [.58, .42], [.08, .34], [0, .36]]), 96).map(p => ({ x: p.x * 1.2, y: p.y * 1.2 })) },
    bag: { color: '#9EE6B8', n: 96, intro: 'Tote time. add to cart?', face: { ey: .02, ex: .27, er: .15, my: .34 },
      lines: [{ t: 'add me to cart →', href: '#contact' }, { t: 'I hold all your orders' }, { t: 'free shipping? for you.' }],
      make: () => resample([{ x: -.62, y: -.66 }, { x: .62, y: -.66 }, { x: .78, y: .8 }, { x: -.78, y: .8 }], 96) }
  };

  class AmbiwBuddy extends HTMLElement {
    static get observedAttributes() { return ['color', 'size', 'shape', 'cycle', 'home']; }
    connectedCallback() {
      this.style.display = 'contents';
      this.inFrame = window.top !== window;
      this.onMsg = e => {
        const d = e.data; if (!d || typeof d !== 'object') return;
        if (d.ambiwBuddyHost && this.inFrame && !this.bridged) { this.bridged = true; this.teardown(); this.bridge(); return; }
        const f = d.ambiwSections || d.ambiwPointer ? [...document.querySelectorAll('iframe')].find(fr => fr.contentWindow === e.source) : null;
        if (!f) return;
        if (d.ambiwSections) { this.ext = this.ext || new Map(); this.ext.set(f, d.ambiwSections); }
        if (d.ambiwPointer && this.state.grab < 0) { const r = f.getBoundingClientRect(); this.onMove({ clientX: r.left + d.ambiwPointer.x, clientY: r.top + d.ambiwPointer.y, preventDefault() {} }); }
      };
      addEventListener('message', this.onMsg);
      const ping = () => document.querySelectorAll('iframe').forEach(fr => { try { fr.contentWindow.postMessage({ ambiwBuddyHost: true }, '*'); } catch (_) {} });
      ping(); this.pingT = setInterval(ping, 1000); setTimeout(() => clearInterval(this.pingT), 15000);
      const cv = this.cv = document.createElement('canvas');
      cv.setAttribute('aria-hidden', 'true');
      cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:' + (this.getAttribute('z') || 9990);
      this.appendChild(cv);
      this.ctx = cv.getContext('2d');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.touch = matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
      this.N = 30; this.sh = SHAPES.delta;
      this.pointer = { x: -999, y: -999, vx: 0, vy: 0, t: 0 };
      this.state = { mode: 'float', face: 'idle', faceT: 0, grab: -1, idle: 0, sleeping: false, blink: 0, nextBlink: 2, spin: 0, dizzy: 0, bubble: null, kickCd: 0 };
      this.resize = this.resize.bind(this);
      this.onDown = this.onDown.bind(this); this.onMove = this.onMove.bind(this); this.onUp = this.onUp.bind(this);
      this.onTouch = e => { if (this.hit(e.touches[0].clientX, e.touches[0].clientY) || this.state.grab >= 0) e.preventDefault(); };
      addEventListener('resize', this.resize);
      this.lastY = scrollY; this.seen = {}; this.scrollV = 0; this.wheeCd = 0;
      this.onScroll = () => { this.scrolled = true; };
      addEventListener('scroll', this.onScroll, { passive: true });
      try { this.played = localStorage.getItem('ambiw-buddy-played') === '1'; } catch (_) {}
      this.age = 0;
      this.onFocus = e => {
        const el = e.target; if (!el || !el.matches || !el.matches('input:not([type=hidden]):not([type=search]),textarea,select')) return;
        const r = el.getBoundingClientRect(); this.lookAt = { x: r.left + Math.min(r.width, 300) / 2, y: r.top + r.height / 2, t: 2.5 }; this.wake();
        if (!this.typed) { this.typed = true; this.state.bubble = { text: pick(['ooh, typing…', 'take your time', "I won't peek. much"]), t: 0, life: 2.2 }; }
      };
      this.onSubmit = e => {
        const f = e.target; if (!f || !f.querySelector || !f.querySelector('textarea,input[type=email]')) return;
        this.wake(); this.setFace('happy', 2); this.confetti(); for (const p of this.pts) p.vy -= 2.4;
        this.state.bubble = { text: 'yay! talk soon', t: 0, life: 2.6 };
      };
      addEventListener('focusin', this.onFocus, true); addEventListener('submit', this.onSubmit, true);
      addEventListener('pointerdown', this.onDown, true);
      addEventListener('pointermove', this.onMove, true);
      addEventListener('pointerup', this.onUp, true);
      addEventListener('pointercancel', this.onUp, true);
      addEventListener('touchstart', this.onTouch, { capture: true, passive: false });
      addEventListener('touchmove', this.onTouch, { capture: true, passive: false });
      this.hitEl = document.createElement('div');
      this.hitEl.setAttribute('aria-hidden', 'true');
      this.hitEl.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;cursor:grab;touch-action:none;display:none;z-index:' + ((+this.getAttribute('z') || 9990) + 1);
      this.appendChild(this.hitEl);
      if (this.inFrame) { cv.style.opacity = '0'; setTimeout(() => { if (!this.bridged) cv.style.transition = 'opacity .4s', cv.style.opacity = '1'; }, 700); }
      this.resize();
      this.build();
      this.last = performance.now(); this.acc = 0;
      const loop = t => { this.raf = requestAnimationFrame(loop); this.frame(t); };
      this.raf = requestAnimationFrame(loop);
    }
    teardown() {
      cancelAnimationFrame(this.raf);
      if (this.cv) this.cv.remove(); if (this.hitEl) this.hitEl.remove();
      removeEventListener('resize', this.resize);
      removeEventListener('scroll', this.onScroll);
      removeEventListener('pointerdown', this.onDown, true);
      removeEventListener('pointermove', this.onMove, true);
      removeEventListener('pointerup', this.onUp, true);
      removeEventListener('pointercancel', this.onUp, true);
      removeEventListener('touchstart', this.onTouch, true);
      removeEventListener('touchmove', this.onTouch, true);
    }
    bridge() {
      const post = m => parent.postMessage(m, '*');
      const send = () => {
        const list = [...document.querySelectorAll('[data-screen-label]')].map(el => {
          const r = el.getBoundingClientRect(), h = (el.querySelector('h1,h2,h3') || el).getBoundingClientRect(), y = scrollY, x = scrollX;
          return { label: el.getAttribute('data-screen-label'), say: el.getAttribute('data-buddy-say'), act: el.getAttribute('data-buddy-act'), top: r.top + y, bottom: r.bottom + y, hx: h.left + x + Math.min(h.width, 400) / 2, hy: h.top + y + Math.min(h.height, 120) / 2 };
        });
        post({ ambiwSections: list });
      };
      send(); [500, 1500, 3000, 6000].forEach(t => setTimeout(send, t));
      addEventListener('resize', send); addEventListener('load', send);
      let q = null;
      addEventListener('pointermove', e => { if (!q) requestAnimationFrame(() => { post({ ambiwPointer: q }); q = null; }); q = { x: e.clientX, y: e.clientY }; }, { passive: true });
    }
    disconnectedCallback() {
      removeEventListener('message', this.onMsg); clearInterval(this.pingT);
      removeEventListener('focusin', this.onFocus, true); removeEventListener('submit', this.onSubmit, true);
      cancelAnimationFrame(this.raf);
      removeEventListener('resize', this.resize);
      removeEventListener('scroll', this.onScroll);
      removeEventListener('pointerdown', this.onDown, true);
      removeEventListener('pointermove', this.onMove, true);
      removeEventListener('pointerup', this.onUp, true);
      removeEventListener('pointercancel', this.onUp, true);
      removeEventListener('touchstart', this.onTouch, true);
      removeEventListener('touchmove', this.onTouch, true);
      document.documentElement.style.cursor = '';
    }
    attributeChangedCallback(n) { if (!this.pts) return;
      if (n === 'home') { const hm = (this.getAttribute('home') || '').split(',').map(Number); if (hm.length === 2 && !isNaN(hm[1])) { this.home = { x: this.W * hm[0], y: this.H * hm[1] }; this.state.mode = 'float'; } return; } if ((n === 'shape' && this.getAttribute('shape') !== this.key) || n === 'cycle') { this.mTo = null; this.drop = null; this.build(true); } else if (n === 'size') this.build(true); }
    get color() { return this.getAttribute('color') || '#8FC2FF'; }
    // resize() {
    //   const d = this.dpr = Math.min(devicePixelRatio || 1, 2);
    //   this.W = innerWidth; this.H = innerHeight;
    //   this.cv.width = this.W * d; this.cv.height = this.H * d;
    //   if (this.home) { this.home.x = Math.min(this.home.x, this.W - this.R * 1.4); this.home.y = Math.min(this.home.y, this.H - this.R * 1.4); }
    // }
    resize() {
      const d = this.dpr = Math.min(devicePixelRatio || 1, 2);
      this.W = innerWidth; this.H = innerHeight;
      this.cv.width = this.W * d; this.cv.height = this.H * d;
      this.cv.style.width = this.W + 'px'; this.cv.style.height = this.H + 'px';
      if (this.home) { this.home.x = Math.min(this.home.x, this.W - this.R * 1.4); this.home.y = Math.min(this.home.y, this.H - this.R * 1.4); }
    }
    build(keep) {
      const base = parseFloat(this.getAttribute('size')) || 64;
      const R = this.R = base * Math.max(0.56, Math.min(1, this.W / 1000));
      const prev = this.key;
      this.key = SHAPES[this.getAttribute('shape')] ? this.getAttribute('shape') : 'delta';
      this.cyc = (this.getAttribute('cycle') || '').split(',').map(s => s.trim()).filter(k => SHAPES[k]);
      if (!this.cyc.length) this.cyc = null; else this.key = keep && prev && this.cyc.includes(prev) ? prev : this.cyc[0];
      const sh = this.sh = SHAPES[this.key];
      this.N = sh.n;
      const rest = this.restOf(this.key, R);
      this.rest = rest;
      const hm = (this.getAttribute('home') || '').split(',').map(Number);
      const c = keep && this.pts ? this.centroid() : hm.length === 2 && !isNaN(hm[1]) ? { x: this.W * hm[0], y: this.H * hm[1] } : { x: this.W - R * 2.2, y: this.H - R * 2.4 };
      this.home = { x: c.x, y: c.y };
      this.pts = rest.map(o => ({ x: c.x + o.x, y: c.y + o.y, vx: 0, vy: 0 }));
      this.angle = 0;
    }
    restOf(key, R) {
      const raw = SHAPES[key].make(); let mx = 0, my = 0; raw.forEach(p => { mx += p.x; my += p.y; }); mx /= raw.length; my /= raw.length;
      return raw.map(p => ({ x: (p.x - mx) * R, y: (p.y - my) * R }));
    }
    morph() { this.morphTo(this.cyc[(this.cyc.indexOf(this.key) + 1) % this.cyc.length]); }
    morphTo(key) { this.mFrom = this.rest.map(p => ({ ...p })); this.mTo = this.restOf(key, this.R); this.mT = 0; this.mKey = key; }
    linkOf(sh) { return (sh.link && this.getAttribute('link-' + sh.link)) || sh.href; }
    markPlayed() { if (this.played) return; this.played = true; try { localStorage.setItem('ambiw-buddy-played', '1'); } catch (_) {} }
    tourName() {
      if (this._tn) return this._tn;
      const a = this.getAttribute('tour'); if (a && a !== 'auto') return this._tn = a;
      const p = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
      if (p === '/') return this._tn = 'home';
      const m = [['amazon-form', 'contact'], ['amazon', 'amazon'], ['retainer', 'retainer'], ['service', 'services'], ['about', 'about'], ['testimonial', 'testimonials'], ['career', 'career'], ['contact', 'contact'], ['/work', 'work']].find(([k]) => p.includes(k));
      return this._tn = m ? m[1] : 'other';
    }
    scanPage() {
      const root = document.querySelector('main') || document.getElementById('MainContent') || document.body, out = [], used = new Set();
      for (const n of root.querySelectorAll('div,span,p,small,em,strong,h6,li,h2')) {
        if (n.closest('header,footer,nav,[role=dialog],cart-drawer,ambiw-buddy')) continue;
        const isH = n.tagName === 'H2';
        if (!isH && n.childElementCount) continue;
        const t = (n.textContent || '').trim().replace(/\s+/g, ' ');
        if (!isH && !/^\(\s*[^)]{2,40}\)$/.test(t)) continue;
        let h = isH ? n : null;
        for (let p = n, i = 0; !h && p && i < 4; i++) { p = p.parentElement; h = p && p.querySelector('h1,h2'); }
        const txt = (t + ' ' + (h && h !== n ? h.textContent : '')).toLowerCase();
        const k = KEYS.find(k => txt.includes(k[0]));
        if (!k || used.has(k[0])) continue; used.add(k[0]);
        out.push({ el: n, h, label: k[0], say: k[1], act: k[2] });
      }
      return out.sort((a, b) => a.el.getBoundingClientRect().top - b.el.getBoundingClientRect().top);
    }
    landLink(c) {
      let el = null;
      for (const e of document.elementsFromPoint(Math.max(0, Math.min(this.W - 1, c.x)), Math.max(0, Math.min(this.H - 1, c.y)))) { el = e.closest && e.closest('a[href]'); if (el) break; }
      if (!el || el.closest('ambiw-buddy')) return false;
      const href = el.getAttribute('href') || '', t = (el.textContent || '').replace(/[→↗]/g, '').trim().replace(/\s+/g, ' ');
      if (!t || t.length > 26 || href === '#' || href.startsWith('javascript') || href.startsWith('tel') || href.startsWith('mailto')) return false;
      this.setFace('happy', 1.4);
      this.state.bubble = { text: t + '? good pick →', href: el.href, t: 0, life: 3.6 };
      return true;
    }
    poof() {
      const c = this.centroid(), col = this.P ? this.P.body : '#fff';
      this.parts = (this.parts || []).concat(Array.from({ length: 16 }, (_, i) => { const a = i / 16 * TAU + Math.random() * .3, s = 3 + Math.random() * 4; return { x: c.x, y: c.y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 1, r: this.R * (.05 + Math.random() * .06), col }; }));
    }
    scrollMood(dt) {
      const dy = scrollY - this.lastY; this.lastY = scrollY;
      this.scrollV += (Math.abs(dy) - this.scrollV) * 0.2; this.wheeCd -= dt;
      if (!dy) return;
      const s = this.state;
      s.idle = 0; s.bored = false; if (s.sleeping) { s.sleeping = false; this.state.bubble = { text: 'oh! we\'re moving', t: 0, life: 1.6 }; }
      if (s.grab >= 0) return;
      const k = Math.max(-1.2, Math.min(1.2, -dy * 0.015)), c = this.centroid();
      for (const p of this.pts) p.vy += k * (1 + (c.y - p.y) / this.R * 0.2);
      if (this.scrollV > 38) { if (s.face === 'idle' || s.face === 'woo') this.setFace('woo', 0.5); if (this.wheeCd <= 0 && !s.bubble) { this.wheeCd = 8; this.state.bubble = { text: 'wheee!', t: 0, life: 1.2 }; } }
    }
    tour(dt) {
      this.tourT = (this.tourT || 0) - dt;
      if (this.tourT > 0) return; this.tourT = 0.25;
      if (this.scrollV > 14 || this.state.grab >= 0) { this.settle = 0; return; }
      const mid = this.H * 0.5;
      let cur = null;
      for (const el of document.querySelectorAll('[data-screen-label]')) {
        const r = el.getBoundingClientRect();
        if (r.top < mid && r.bottom > mid) { const h = (el.querySelector('h1,h2,h3') || el).getBoundingClientRect(); cur = { label: el.getAttribute('data-screen-label'), say: el.getAttribute('data-buddy-say'), act: el.getAttribute('data-buddy-act'), hx: h.left + Math.min(h.width, 400) / 2, hy: h.top + Math.min(h.height, 120) / 2 }; }
      }
      if (!document.querySelector('[data-screen-label]')) {
        this.scanT = (this.scanT || 0) - 0.25;
        if (this.scanT <= 0 || !this.scan) { this.scanT = 3; this.scan = this.scanPage(); }
        if (scrollY < this.H * 0.3) {
          const h = (document.querySelector('main h1, #MainContent h1, h1') || document.body).getBoundingClientRect();
          cur = { label: 'Hero', hx: h.left + Math.min(h.width, 400) / 2, hy: h.top + Math.min(h.height, 120) / 2 };
        } else for (const sc of this.scan) {
          if (!sc.el.isConnected) continue;
          if (sc.el.getBoundingClientRect().top < mid) { const h = (sc.h || sc.el).getBoundingClientRect(); cur = { label: sc.label, say: sc.say, act: sc.act, hx: h.left + Math.min(h.width, 400) / 2, hy: h.top + Math.min(h.height, 120) / 2 }; }
        }
      }
      if (this.ext) for (const [f, list] of this.ext) {
        if (!f.isConnected) continue;
        const fr = f.getBoundingClientRect();
        for (const sct of list) if (fr.top + sct.top < mid && fr.top + sct.bottom > mid) cur = { ...sct, hx: fr.left + sct.hx, hy: fr.top + sct.hy };
      }
      if (!cur) return;
      const key = cur.label;
      if (key !== this.tourKey) { this.tourKey = key; this.settle = 0; return; }
      this.settle = (this.settle || 0) + 1;
      if (this.settle !== 2 || this.seen[key]) return;
      const entry = cur.say ? [cur.say, cur.act || 'look'] : ((TOUR[this.tourName()] || {})[key] || COMMON[key]);
      if (!entry) return;
      this.seen[key] = true;
      this.react(entry[1], cur, entry[0]);
    }
    react(type, sct, text) {
      const s = this.state; this.wake();
      const tx = Math.max(0, Math.min(this.W, sct.hx)), ty = Math.max(0, Math.min(this.H, sct.hy));
      this.lookAt = { x: tx, y: ty, t: 3 };
      this.act = { type, t: 0 };
      if (text) s.bubble = { text, t: 0, life: 2.8 };
      const c = this.centroid(), dx = tx - c.x, dy = ty - c.y, dl = Math.hypot(dx, dy) || 1;
      if (type === 'point') { for (const p of this.pts) { p.vx += dx / dl * 1.6; p.vy += dy / dl * 1; } this.setFace('woo', 1.2); }
      else if (type === 'cheer') { for (const p of this.pts) p.vy -= 2.2; this.setFace('happy', 1.8); this.confetti(); }
      else if (type === 'happy') this.setFace('happy', 1.6);
      else if (type === 'look') { for (const p of this.pts) { p.vx += dx / dl * .7; p.vy += dy / dl * .45; } }
    }
    confetti() {
      if (this.reduced) return;
      const c = this.centroid();
      this.parts = (this.parts || []).concat(Array.from({ length: 22 }, () => { const a = -Math.PI / 2 + (Math.random() - .5) * 1.8, sp = 4 + Math.random() * 5; return { x: c.x, y: c.y - this.R * .5, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1.3, r: this.R * (.04 + Math.random() * .04), col: pick(CONFETTI), g: true }; }));
    }
    centroid() { let x = 0, y = 0; for (const p of this.pts) { x += p.x; y += p.y; } return { x: x / this.N, y: y / this.N }; }
    hit(x, y) {
      const P = this.pts; let inside = false;
      if (this.touch) { const c = this.centroid(); if (Math.hypot(x - c.x, y - c.y) < Math.max(this.R * 0.95, 34)) return true; }
      for (let i = 0, j = P.length - 1; i < P.length; j = i++) {
        if ((P[i].y > y) !== (P[j].y > y) && x < (P[j].x - P[i].x) * (y - P[i].y) / (P[j].y - P[i].y) + P[i].x) inside = !inside;
      }
      return inside;
    }
    say(kind, ms = 1700) {
      let l;
      if (kind === 'poke') {
        const own = this.sh.lines || [], list = LINES.poke.slice();
        own.forEach((o, i) => list.splice(1 + i * 4, 0, o));
        this.pk = ((this.pk ?? -1) + 1) % list.length; l = list[this.pk]; ms = l.href ? 3600 : 2400;
      }
      else l = { t: pick(LINES[kind]) };
      this.state.bubble = { text: l.t, href: (l.link && this.getAttribute('link-' + l.link)) || l.href, t: 0, life: ms / 1000 };
    }
    inBubble(x, y) { const b = this.state.bubble, r = b && b.rect; return !!(r && b.href && x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h); }
    sampleBg() {
      const c = this.centroid();
      const els = document.elementsFromPoint(Math.max(0, Math.min(this.W - 1, c.x)), Math.max(0, Math.min(this.H - 1, c.y)));
      let lum = null;
      for (const el of els) {
        if (el === this.cv) continue;
        const m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
        if (m && (m[3] === undefined || +m[3] > 0.5)) { lum = (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255; break; }
      }
      if (lum === null) lum = 1;
      this.darkBg = lum < 0.45;
    }
    pal() {
      const hex = h => { h = h.replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); return [0, 2, 4].map(i => parseInt(h.substr(i, 2), 16)); };
      const tgt = this.darkBg !== false
        ? { body: hex(this.getAttribute('color') || this.sh.color), ink: [20, 22, 27], bub: [244, 244, 242], bubInk: [20, 22, 27] }
        : { body: hex(this.sh.light ? (this.getAttribute('color-light') || this.sh.light) : (this.getAttribute('color') || this.sh.color)), ink: this.sh.light ? [244, 244, 242] : [20, 22, 27], bub: [20, 22, 27], bubInk: [244, 244, 242] };
      if (!this.cur) this.cur = JSON.parse(JSON.stringify(tgt));
      for (const k in tgt) this.cur[k] = this.cur[k].map((v, i) => v + (tgt[k][i] - v) * 0.12);
      const f = a => 'rgb(' + a.map(Math.round).join(',') + ')';
      return { body: f(this.cur.body), ink: f(this.cur.ink), bub: f(this.cur.bub), bubInk: f(this.cur.bubInk) };
    }
    setFace(f, dur) { this.state.face = f; this.state.faceT = dur; }
    wake() { const s = this.state; s.idle = 0; s.bored = false; if (s.sleeping) { s.sleeping = false; this.say('wake'); } }
    onDown(e) {
      if (this.inBubble(e.clientX, e.clientY)) {
        e.preventDefault(); e.stopPropagation();
        const href = this.state.bubble.href; this.state.bubble = null;
        if (href[0] === '#') { const t = document.querySelector(href); if (!t) { location.href = this.getAttribute('link-contact') || href; return; } scrollTo({ top: t.getBoundingClientRect().top + scrollY - 80, behavior: 'smooth' }); }
        else location.href = href;
        return;
      }
      if (!this.hit(e.clientX, e.clientY)) return;
      e.preventDefault(); e.stopPropagation();
      this.wake(); this.markPlayed();
      if (e.pointerType === 'touch') this.touch = true;
      const P0 = this.pointer, c0 = this.centroid();
      P0.x = e.clientX; P0.y = e.clientY; P0.t = performance.now(); P0.vx = P0.vy = P0.svx = P0.svy = 0;
      this.grabOff = { x: e.clientX - c0.x, y: e.clientY - c0.y };
      let best = 0, bd = 1e9;
      this.pts.forEach((p, i) => { const d = (p.x - e.clientX) ** 2 + (p.y - e.clientY) ** 2; if (d < bd) { bd = d; best = i; } });
      if (e.target === this.hitEl && e.pointerId != null) try { this.hitEl.setPointerCapture(e.pointerId); } catch (_) {}
      const s = this.state; s.grab = best; s.mode = 'drag'; s.down = { x: e.clientX, y: e.clientY, t: performance.now() };
      this.setFace('grab', 999);
      document.documentElement.style.cursor = 'grabbing';
      const kill = ev => { ev.stopPropagation(); ev.preventDefault(); removeEventListener('click', kill, true); };
      addEventListener('click', kill, true); setTimeout(() => removeEventListener('click', kill, true), 600);
    }
    onMove(e) {
      const P = this.pointer, now = performance.now(), dt = Math.max(8, now - P.t);
      if (P.t) { P.vx = (e.clientX - P.x) / dt * 16; P.vy = (e.clientY - P.y) / dt * 16; P.svx = (P.svx || 0) * 0.5 + P.vx * 0.5; P.svy = (P.svy || 0) * 0.5 + P.vy * 0.5; }
      P.x = e.clientX; P.y = e.clientY; P.t = now;
      const s = this.state;
      if (s.grab >= 0) { e.preventDefault(); return; }
      const over = this.hit(P.x, P.y);
      document.documentElement.style.cursor = over ? 'grab' : this.inBubble(P.x, P.y) ? 'pointer' : '';
      const c = this.centroid(), near = Math.hypot(P.x - c.x, P.y - c.y) < this.R * 3;
      if (near) this.wake();
      const sp = Math.hypot(P.vx, P.vy);
      if (over && sp > 16 && s.kickCd <= 0) this.kick(P.vx, P.vy, P.x, P.y);
    }
    onUp(e) {
      const s = this.state; if (s.grab < 0) return;
      e.stopPropagation();
      const d = s.down, moved = Math.hypot(e.clientX - d.x, e.clientY - d.y), quick = performance.now() - d.t < 260;
      s.grab = -1; s.mode = 'free';
      document.documentElement.style.cursor = this.hit(e.clientX, e.clientY) ? 'grab' : '';
      if (moved < 6 && quick) return this.poke();
      const P = this.pointer, fresh = performance.now() - P.t < (this.touch ? 140 : 90), tvx = fresh ? P.svx || 0 : 0, tvy = fresh ? P.svy || 0 : 0;
      const sp = Math.hypot(tvx, tvy), m = Math.min(1, 30 / (sp || 1)), av = this.avgV();
      for (const p of this.pts) { p.vx += (tvx * m - av.x) * 0.7; p.vy += (tvy * m - av.y) * 0.7; }
      this.setFace(sp > 9 ? 'woo' : 'idle', 0.8);
      if (sp > 22) this.say('throw', 1200);
    }
    avgV() { let x = 0, y = 0; for (const p of this.pts) { x += p.vx; y += p.vy; } return { x: x / this.N, y: y / this.N }; }
    poke() {
      const c = this.centroid();
      for (const p of this.pts) { p.vy -= 2.4; const dx = p.x - c.x; p.vx += dx * 0.03; p.vy += (p.y - c.y) * -0.02; }
      this.state.mode = 'free'; this.setFace('happy', 1.1);
      const now = performance.now();
      this.combo = now - (this.lastPoke || 0) < 1500 ? (this.combo || 0) + 1 : 1; this.lastPoke = now; this.comboShow = 1.4;
      const n = this.combo;
      if (this.cyc && this.cyc.length > 1) return this.morph();
      if (this.key !== 'delta') this.backT = Math.max(this.backT || 0, 8);
      if (n === 5 && !this.mTo) { this.morphTo(pick(['cart', 'plus', 'parcel', 'calendar', 'card'].filter(k => k !== this.key))); this.backT = 12; }
      else if (n === 10) { this.confetti(); this.setFace('happy', 2); this.state.bubble = { text: "you're a natural. free audit? →", href: this.getAttribute('link-contact') || '#contact', t: 0, life: 4.5 }; }
      else if (n === 3) this.state.bubble = { text: 'keep going…', t: 0, life: 1.2 };
      else if (n > 10 && n % 5 === 0) { this.confetti(); this.state.bubble = { text: pick(["ok, we're best friends now", 'combo ×' + n + '!', 'unstoppable']), t: 0, life: 2.2 }; }
      else this.say('poke');
    }
    kick(vx, vy, x, y) {
      const s = this.state, c = this.centroid(), m = Math.min(1, 34 / Math.hypot(vx, vy));
      vx *= m * 0.9; vy *= m * 0.9;
      const lx = x - c.x, ly = y - c.y;
      for (const p of this.pts) {
        const rx = p.x - c.x, ry = p.y - c.y;
        const tq = (lx * vy - ly * vx) / (this.R * this.R) * 0.25;
        p.vx += vx - ry * tq; p.vy += vy + rx * tq;
      }
      s.mode = 'free'; s.kickCd = 0.35; this.setFace('ouch', 0.9); this.say('kick', 1200); this.wake(); this.markPlayed();
    }
    step(dt) {
      if (this.mTo) {
        this.mT = Math.min(1, this.mT + dt / .38);
        const e = this.mT < .5 ? 2 * this.mT * this.mT : 1 - Math.pow(-2 * this.mT + 2, 2) / 2;
        this.rest = this.mFrom.map((p, i) => ({ x: p.x + (this.mTo[i].x - p.x) * e, y: p.y + (this.mTo[i].y - p.y) * e }));
        if (this.mT >= .5 && this.key !== this.mKey) {
          this.key = this.mKey; this.sh = SHAPES[this.key]; this.pk = -1; this.poof();
          const ih = this.linkOf(this.sh); this.state.bubble = { text: this.sh.intro, href: ih, t: 0, life: ih ? 3.6 : 2.4 };
          if (this.key === 'cart') { this.drop = { t: 0 }; this.cartN = (this.cartN || 0) + 1; }
          this.dispatchEvent(new CustomEvent('shapechange', { detail: this.key, bubbles: true }));
        }
        if (this.mT >= 1) { this.rest = this.mTo; this.mTo = null; }
      }
      const s = this.state, P = this.pts, N = this.N, c = this.centroid(), R = this.R;
      if (this.act && this.act.type === 'wave' && this.act.t < 1.4 && !this.reduced) { const w = Math.sin(this.act.t * 7) * .22; for (const p of P) { p.vx += -(p.y - c.y) / R * w; p.vy += (p.x - c.x) / R * w; } }
      let num = 0, den = 0;
      for (let i = 0; i < N; i++) { const o = this.rest[i], dx = P[i].x - c.x, dy = P[i].y - c.y; num += o.x * dy - o.y * dx; den += o.x * dx + o.y * dy; }
      let a = Math.atan2(num, den);
      const da = ((a - this.angle + Math.PI * 3) % TAU) - Math.PI;
      this.angle = a; s.spin += Math.abs(da);
      const up = s.mode === 'float' ? 0.04 : 0.008;
      const ta = a * (1 - up), ca = Math.cos(ta), sa = Math.sin(ta);
      const v = this.avgV(), K = 0.11;
      for (let i = 0; i < N; i++) {
        const p = P[i], o = this.rest[i];
        const tx = c.x + o.x * ca - o.y * sa, ty = c.y + o.x * sa + o.y * ca;
        p.vx += (tx - p.x) * K; p.vy += (ty - p.y) * K;
        p.vx += (v.x - p.vx) * 0.12; p.vy += (v.y - p.vy) * 0.12;
      }
      if (s.grab >= 0) {
        const g = P[s.grab], ptr = this.pointer, o = this.grabOff || { x: 0, y: 0 };
        const ex = ptr.x - o.x - c.x, ey = ptr.y - o.y - c.y, dvx = ex * 0.3 - v.x, dvy = ey * 0.3 - v.y;
        for (const p of P) { p.vx += dvx * 0.55; p.vy += dvy * 0.55; }
        g.vx += (ptr.x - g.x) * 0.05; g.vy += (ptr.y - g.y) * 0.05;
      } else if (s.mode === 'free') {
        if (Math.hypot(v.x, v.y) < 0.5) { s.mode = 'float'; const top = parseFloat(this.getAttribute('top-safe') || 90);
          this.home = { x: Math.max(R * 1.6, Math.min(this.W - R * 1.6, c.x)), y: Math.max(R * 1.8 + top, Math.min(this.H - R * 1.6, c.y)) }; if (!this.landLink(c) && Math.random() < 0.25) this.say('land', 1200); }
      } else {
        this.t = (this.t || 0) + dt;
        const bob = this.reduced ? 0 : Math.sin(this.t * 1.1) * R * 0.08;
        const drift = this.reduced || s.sleeping ? 0 : Math.sin(this.t * 0.37) * R * 0.25;
        const fx = (this.home.x + drift - c.x) * 0.0022, fy = (this.home.y + bob - c.y) * 0.004;
        for (const p of P) { p.vx += fx; p.vy += fy; }
      }
      const air = s.grab >= 0 ? 0.94 : s.mode === 'float' ? 0.965 : 0.982, pad = 4;
      for (const p of P) {
        p.vx *= air; p.vy *= air;
        p.x += p.vx; p.y += p.vy;
        if (p.x < pad) { p.x = pad; p.vx = Math.abs(p.vx) * 0.55; p.vy *= 0.9; }
        if (p.x > this.W - pad) { p.x = this.W - pad; p.vx = -Math.abs(p.vx) * 0.55; p.vy *= 0.9; }
        if (p.y < pad) { p.y = pad; p.vy = Math.abs(p.vy) * 0.55; p.vx *= 0.9; }
        if (p.y > this.H - pad) { p.y = this.H - pad; p.vy = -Math.abs(p.vy) * 0.55; p.vx *= 0.9; }
      }
    }
    frame(now) {
      let dt = Math.min(0.05, (now - this.last) / 1000); this.last = now;
      const s = this.state;
      this.acc += dt;
      while (this.acc >= 1 / 60) { this.step(1 / 60); this.acc -= 1 / 60; }
      s.kickCd -= dt; s.faceT -= dt; s.spin *= Math.pow(0.35, dt);
      if (s.spin > TAU * 1.6 && s.dizzy <= 0) { s.dizzy = 2.6; this.say('dizzy', 2200); }
      s.dizzy -= dt;
      if (s.faceT <= 0 && s.grab < 0) s.face = 'idle';
      this.scrollMood(dt);
      if (this.hasAttribute('tour')) this.tour(dt);
      this.age += dt; this.comboShow = (this.comboShow || 0) - dt;
      if (!this.played && !this.hinted && this.age > 4 && !s.bubble && s.grab < 0) { this.hinted = true; s.bubble = { text: this.touch ? 'psst… tap me, or fling me' : 'psst… drag me, throw me, poke me', t: 0, life: 3.2 }; }
      if (this.backT > 0 && !this.mTo && s.grab < 0) { this.backT -= dt; if (this.backT <= 0) this.morphTo('delta'); }
      if (this.act) this.act.t += dt;
      if (this.lookAt) { this.lookAt.t -= dt; if (this.lookAt.t <= 0) this.lookAt = null; }
      s.idle += dt;
      if (s.idle > 7 && !s.sleeping && s.face === 'idle' && !s.bored) { s.bored = true; if (!this.boredSaid) { this.boredSaid = true; this.state.bubble = { text: pick(BORED), t: 0, life: 2.4 }; } }
      if (s.idle > 16 && !s.sleeping && s.mode === 'float') s.sleeping = true;
      s.nextBlink -= dt; if (s.nextBlink <= 0) { s.blink = 0.14; s.nextBlink = 2 + Math.random() * 3.5; }
      s.blink -= dt;
      this.bgT = (this.bgT || 0) - dt; if (this.bgT <= 0) { this.bgT = 0.2; this.sampleBg(); }
      if (s.bubble) { s.bubble.t += dt; if (s.bubble.t > s.bubble.life) s.bubble = null; }
      this.draw(now / 1000);
      if (this.hitEl) {
        const host = this.touch || !!document.querySelector('iframe');
        if (host) { let a = 1e9, b = 1e9, c2 = -1e9, d2 = -1e9; for (const p of this.pts) { a = Math.min(a, p.x); b = Math.min(b, p.y); c2 = Math.max(c2, p.x); d2 = Math.max(d2, p.y); }
          const pad = this.touch ? 10 : 0; a -= pad; b -= pad; c2 += pad; d2 += pad;
          Object.assign(this.hitEl.style, { display: 'block', left: a + 'px', top: b + 'px', width: (c2 - a) + 'px', height: (d2 - b) + 'px', cursor: s.grab >= 0 ? 'grabbing' : 'grab' }); }
        else this.hitEl.style.display = 'none';
      }
    }
    draw(t) {
      const x = this.ctx, d = this.dpr, P = this.pts, N = this.N, s = this.state, R = this.R, pal = this.P = this.pal(), col = pal.body;
      x.setTransform(d, 0, 0, d, 0, 0); x.clearRect(0, 0, this.W, this.H);
      const c = this.centroid();
      if (!this.played && this.age > 3 && !this.reduced) { const k = (t * 0.7) % 1; x.save(); x.strokeStyle = col; x.globalAlpha = (1 - k) * 0.55; x.lineWidth = 2; x.beginPath(); x.arc(c.x, c.y, R * (0.95 + k * 0.75), 0, TAU); x.stroke(); x.restore(); }
      if (this.key !== 'delta') { x.save(); x.translate(c.x, c.y); x.rotate(this.angle); this.pre(t, col); x.restore(); }
      x.save();
      x.shadowColor = 'rgba(6,10,20,0.35)'; x.shadowBlur = R * 0.5; x.shadowOffsetY = R * 0.28;
      x.beginPath();
      for (let i = 0; i <= N; i++) {
        const p = P[i % N], q = P[(i + 1) % N], mx = (p.x + q.x) / 2, my = (p.y + q.y) / 2;
        i === 0 ? x.moveTo(mx, my) : x.quadraticCurveTo(p.x, p.y, mx, my);
      }
      x.closePath(); x.fillStyle = col; x.fill();
      x.restore();
      x.save(); x.clip();
      const g = x.createRadialGradient(c.x - R * 0.35, c.y - R * 0.5, 0, c.x - R * 0.35, c.y - R * 0.5, R * 1.3);
      g.addColorStop(0, 'rgba(255,255,255,0.38)'); g.addColorStop(1, 'rgba(255,255,255,0)');
      x.fillStyle = g; x.fillRect(c.x - R * 2, c.y - R * 2, R * 4, R * 4);
      x.fillStyle = 'rgba(0,40,110,0.12)';
      x.beginPath(); x.ellipse(c.x + R * 0.3, c.y + R * 0.95, R * 1.3, R * 0.5, 0, 0, TAU); x.fill();
      x.restore();
      // squash for face
      const ca = Math.cos(this.angle), sa = Math.sin(this.angle);
      let mnx = 1e9, mxx = -1e9, mny = 1e9, mxy = -1e9;
      for (const p of P) { const lx = (p.x - c.x) * ca + (p.y - c.y) * sa, ly = -(p.x - c.x) * sa + (p.y - c.y) * ca; mnx = Math.min(mnx, lx); mxx = Math.max(mxx, lx); mny = Math.min(mny, ly); mxy = Math.max(mxy, ly); }
      const fsx = Math.max(0.7, Math.min(1.35, (mxx - mnx) / (R * 1.55))), fsy = Math.max(0.7, Math.min(1.35, (mxy - mny) / (R * 1.42)));
      x.save(); x.translate(c.x, c.y); x.rotate(this.angle); x.scale(fsx, fsy);
      this.post(t);
      this.face(t);
      x.restore();
      if (this.parts && this.parts.length) {
        this.parts = this.parts.filter(p => (p.life -= .03) > 0);
        for (const p of this.parts) { p.x += p.vx; p.y += p.vy; if (p.g) { p.vy += .25; p.vx *= .98; } else { p.vx *= .92; p.vy *= .92; } x.globalAlpha = Math.min(1, p.life); x.fillStyle = p.col; x.beginPath(); x.arc(p.x, p.y, p.r * (0.5 + p.life * .5), 0, TAU); x.fill(); }
        x.globalAlpha = 1;
      }
      if (this.drop) this.cartFx(c);
      if (s.sleeping) this.zzz(c, t);
      if (s.bubble) this.bubble(c);
      if (this.comboShow > 0 && this.combo >= 2) this.comboTag(c);
    }
    comboTag(c) {
      const x = this.ctx, R = this.R, fs = Math.max(12, R * 0.26), a = Math.min(1, this.comboShow * 3), pop = 1 + Math.max(0, this.comboShow - 1.15) * 2;
      x.save(); x.globalAlpha = a; x.font = `800 ${fs}px 'Hanken Grotesk',system-ui,sans-serif`; x.textAlign = 'center'; x.textBaseline = 'middle';
      const label = '×' + this.combo, w = x.measureText(label).width + fs, h = fs * 1.6;
      const px = Math.max(w / 2 + 6, c.x - R * 1.15), py = c.y - R * 0.6 - (1.4 - this.comboShow) * R * 0.25;
      x.translate(px, py); x.scale(pop, pop);
      x.fillStyle = this.combo >= 5 ? '#FFC94D' : this.P.bub; x.beginPath(); x.roundRect(-w / 2, -h / 2, w, h, h / 2); x.fill();
      x.fillStyle = this.combo >= 5 ? '#14161B' : this.P.bubInk; x.fillText(label, 0, 1); x.restore();
    }
    face(t) {
      const x = this.ctx, s = this.state, R = this.R, ink = this.P.ink, pupil = '#14161B';
      const F = this.sh.face, ey = R * F.ey, ex = R * F.ex, er = R * F.er;
      x.save(); x.translate(R * (F.fx || 0), 0);
      const f = s.dizzy > 0 ? 'dizzy' : s.sleeping ? 'sleep' : s.bored && s.face === 'idle' ? 'bored' : s.face;
      const v = this.avgV(), sp = Math.hypot(v.x, v.y);
      const c = this.centroid(), ptr = this.lookAt || this.pointer;
      let lx = ptr.x - c.x, ly = ptr.y - c.y;
      const ca = Math.cos(-this.angle), sa = Math.sin(-this.angle);
      [lx, ly] = [lx * ca - ly * sa, lx * sa + ly * ca];
      const ll = Math.hypot(lx, ly) || 1, lk = Math.min(1, ll / (R * 4)) * er * 0.45;
      if (ptr.x < -900) { lx = 0; ly = 0; }
      const px = lx / ll * lk, py = ly / ll * lk;
      x.lineCap = 'round'; x.lineJoin = 'round'; x.strokeStyle = ink; x.fillStyle = ink; x.lineWidth = R * 0.065;
      for (const sx of [-1, 1]) {
        const cx = sx * ex;
        x.save(); x.translate(cx, ey);
        if (f === 'happy' || f === 'sleep') {
          x.beginPath();
          f === 'happy' ? x.arc(0, er * 0.35, er * 0.7, Math.PI * 1.15, Math.PI * 1.85) : x.arc(0, -er * 0.15, er * 0.65, Math.PI * 0.15, Math.PI * 0.85);
          x.stroke();
        } else if (f === 'ouch') {
          const k = er * 0.55; x.beginPath();
          x.moveTo(-k * sx, -k); x.lineTo(k * sx, 0); x.lineTo(-k * sx, k); x.stroke();
        } else if (f === 'dizzy') {
          x.rotate(t * 8 * sx); x.beginPath();
          for (let a = 0; a < TAU * 2.2; a += 0.25) { const r = er * 0.8 * a / (TAU * 2.2); x.lineTo(Math.cos(a) * r, Math.sin(a) * r); }
          x.lineWidth = R * 0.045; x.stroke();
        } else {
          const open = s.blink > 0 ? 0.12 : f === 'woo' || f === 'grab' ? 1.15 : 1;
          const bored = f === 'bored' && s.blink <= 0;
          x.fillStyle = '#FFFFFF'; x.beginPath(); x.ellipse(0, 0, er, er * 1.12 * open, 0, 0, TAU); x.fill();
          if (open > 0.5) {
            x.fillStyle = pupil; x.beginPath(); x.ellipse(px, py, er * 0.52, er * 0.58, 0, 0, TAU); x.fill();
            x.fillStyle = '#FFFFFF'; x.beginPath(); x.arc(px - er * 0.18, py - er * 0.22, er * 0.16, 0, TAU); x.fill();
          }
          if (bored) {
            x.fillStyle = this.P.body; x.fillRect(-er * 1.2, -er * 1.4, er * 2.4, er * 1.3);
            x.strokeStyle = ink; x.lineWidth = R * 0.045; x.beginPath(); x.moveTo(-er * 1.05, -er * 0.1); x.lineTo(er * 1.05, -er * 0.1); x.stroke();
          }
        }
        x.restore();
      }
      x.fillStyle = 'rgba(255,120,150,0.28)';
      for (const sx of [-1, 1]) { x.beginPath(); x.ellipse(sx * (ex + R * 0.2), R * (F.my - 0.04), R * 0.1, R * 0.06, 0, 0, TAU); x.fill(); }
      const my = R * F.my; x.fillStyle = ink; x.strokeStyle = ink;
      x.beginPath();
      if (f === 'woo' || f === 'grab' || (sp > 8 && f !== 'happy')) { x.ellipse(0, my, R * 0.08, R * 0.1, 0, 0, TAU); x.fill(); }
      else if (f === 'happy') { x.moveTo(-R * 0.13, my - R * 0.03); x.quadraticCurveTo(0, my + R * 0.2, R * 0.13, my - R * 0.03); x.closePath(); x.fill(); }
      else if (f === 'ouch' || f === 'dizzy') { x.moveTo(-R * 0.1, my); for (let i = 1; i <= 4; i++) x.lineTo(-R * 0.1 + i * R * 0.05, my + (i % 2 ? -1 : 1) * R * 0.03); x.lineWidth = R * 0.045; x.stroke(); }
      else if (f === 'sleep') { x.ellipse(0, my, R * 0.04, R * 0.035, 0, 0, TAU); x.fill(); }
      else if (f === 'bored') { x.moveTo(-R * 0.08, my - R * 0.02); x.lineTo(R * 0.08, my - R * 0.03); x.lineWidth = R * 0.05; x.stroke(); }
      else { x.arc(0, my - R * 0.06, R * 0.09, Math.PI * 0.2, Math.PI * 0.8); x.lineWidth = R * 0.05; x.stroke(); }
      x.restore();
    }
    pre(t, col) {
      const x = this.ctx, R = this.R, k = this.key;
      x.lineCap = 'round'; x.strokeStyle = col;
      if (k === 'kitty') {
        const w = this.reduced ? 0 : Math.sin(t * 3) * .25;
        x.lineWidth = R * .2; x.beginPath(); x.moveTo(R * .5, R * .5);
        x.bezierCurveTo(R * 1.2, R * .7, R * (1.25 + w * .4), R * (.05 + w * .2), R * (1.0 + w), R * (-.3 + Math.abs(w) * .3)); x.stroke();
      } else if (k === 'leaf') {
        x.lineWidth = R * .1; x.beginPath(); x.moveTo(0, R * .3); x.quadraticCurveTo(R * .04, R * .7, R * .12, R * 1.0); x.stroke();
      } else if (k === 'cart') {
        x.strokeStyle = '#2A2D35'; x.lineWidth = R * .09;
        x.beginPath(); x.moveTo(-R * .8, -R * .4); x.lineTo(-R * 1.0, -R * .78); x.lineTo(-R * 1.22, -R * .78); x.stroke();
        x.beginPath(); x.moveTo(-R * .55, R * .4); x.lineTo(-R * .62, R * .62); x.lineTo(R * .6, R * .62); x.stroke();
        x.fillStyle = '#2A2D35';
        for (const wx of [-R * .45, R * .45]) { x.beginPath(); x.arc(wx, R * .74, R * .13, 0, TAU); x.fill(); }
      } else if (k === 'calendar') {
        x.strokeStyle = '#2A2D35'; x.lineWidth = R * .1;
        for (const s of [-1, 1]) { x.beginPath(); x.moveTo(s * R * .4, -R * .98); x.lineTo(s * R * .4, -R * .58); x.stroke(); }
      } else if (k === 'bag' || k === 'plus') {
        x.lineWidth = R * .11; x.beginPath(); x.moveTo(-R * .34, -R * .5);
        x.bezierCurveTo(-R * .36, -R * 1.42, R * .36, -R * 1.42, R * .34, -R * .5); x.stroke();
        x.strokeStyle = 'rgba(0,0,0,0.22)'; x.stroke();
      }
    }
    post(t) {
      const x = this.ctx, R = this.R, k = this.key, F = this.sh.face, ink = this.P.ink;
      x.lineCap = 'round';
      if (k === 'kitty') {
        x.fillStyle = 'rgba(255,120,150,0.55)';
        for (const s of [-1, 1]) { x.beginPath(); x.moveTo(s * R * .54, -R * .6); x.lineTo(s * R * .68, -R * .84); x.lineTo(s * R * .38, -R * .72); x.closePath(); x.fill(); }
        x.fillStyle = '#E86A8A'; const ny = R * (F.my - .1);
        x.beginPath(); x.moveTo(-R * .06, ny - R * .04); x.lineTo(R * .06, ny - R * .04); x.lineTo(0, ny + R * .03); x.closePath(); x.fill();
        x.strokeStyle = ink; x.lineWidth = R * .025; x.globalAlpha = .7;
        for (const s of [-1, 1]) for (const a of [-.14, 0, .14]) { x.beginPath(); x.moveTo(s * R * .5, ny + a * R * .3); x.lineTo(s * R * .95, ny + a * R * 1.4); x.stroke(); }
        x.globalAlpha = 1;
      } else if (k === 'leaf') {
        x.strokeStyle = 'rgba(0,0,0,0.12)'; x.lineWidth = R * .03;
        for (const [a, b] of [[0, -.95], [.82, -.42], [-.82, -.42], [.52, .3], [-.52, .3]]) { x.beginPath(); x.moveTo(0, R * .32); x.lineTo(a * R * .75, b * R * .75); x.stroke(); }
      } else if (k === 'bag' || k === 'plus') {
        x.strokeStyle = 'rgba(0,0,0,0.12)'; x.lineWidth = R * .03;
        x.beginPath(); x.moveTo(-R * .6, -R * .48); x.lineTo(R * .6, -R * .48); x.stroke();
        if (k === 'plus') {
          x.fillStyle = '#14161B'; x.beginPath(); x.arc(R * .5, -R * .28, R * .15, 0, TAU); x.fill();
          x.strokeStyle = '#95E0A8'; x.lineWidth = R * .05; x.beginPath(); x.moveTo(R * .42, -R * .28); x.lineTo(R * .58, -R * .28); x.moveTo(R * .5, -R * .36); x.lineTo(R * .5, -R * .2); x.stroke();
        }
      } else if (k === 'cart') {
        x.strokeStyle = 'rgba(0,0,0,0.12)'; x.lineWidth = R * .03;
        x.beginPath(); x.moveTo(-R * .8, -R * .24); x.lineTo(R * .8, -R * .24); x.stroke();
      } else if (k === 'card') {
        x.fillStyle = '#F1CF6A'; x.beginPath(); x.roundRect(-R * .82, -R * .4, R * .3, R * .22, R * .04); x.fill();
        x.strokeStyle = 'rgba(0,0,0,0.2)'; x.lineWidth = R * .02; x.beginPath(); x.moveTo(-R * .82, -R * .29); x.lineTo(-R * .52, -R * .29); x.moveTo(-R * .67, -R * .4); x.lineTo(-R * .67, -R * .18); x.stroke();
        x.fillStyle = 'rgba(0,0,0,0.14)';
        for (let i = 0; i < 4; i++) { x.beginPath(); x.roundRect(R * (.1 + i * .2), R * .42, R * .14, R * .06, R * .03); x.fill(); }
      } else if (k === 'parcel') {
        x.fillStyle = 'rgba(255,255,255,0.28)'; x.fillRect(-R * .82, -R * .66, R * 1.64, R * .2);
        x.strokeStyle = 'rgba(0,0,0,0.14)'; x.lineWidth = R * .03; x.beginPath(); x.moveTo(0, -R * .66); x.lineTo(0, -R * .46); x.stroke();
        x.fillStyle = '#F4F4F2'; x.beginPath(); x.roundRect(R * .4, R * .38, R * .3, R * .2, R * .03); x.fill();
        x.fillStyle = 'rgba(0,0,0,0.3)'; for (let i = 0; i < 3; i++) x.fillRect(R * .45, R * (.42 + i * .045), R * (.2 - i * .05), R * .02);
      } else if (k === 'calendar') {
        x.fillStyle = 'rgba(0,0,0,0.16)'; x.beginPath(); x.roundRect(-R * .76, -R * .74, R * 1.52, R * .32, [R * .14, R * .14, 0, 0]); x.fill();
      } else if (k === 'puzzle') {
        x.fillStyle = 'rgba(255,255,255,0.35)';
        for (const [a, b] of [[-.42, -.42], [.42, .42]]) { x.beginPath(); x.arc(a * R, b * R, R * .04, 0, TAU); x.fill(); }
      } else if (k === 'cursor') {
        x.strokeStyle = 'rgba(255,255,255,0.45)'; x.lineWidth = R * .035;
        x.beginPath(); x.moveTo(-R * .48, -R * .78); x.lineTo(-R * .48, -R * .5); x.stroke();
      }
    }
    cartFx(c) {
      const x = this.ctx, R = this.R, d = this.drop; d.t += 1 / 60;
      const ca = Math.cos(this.angle), sa = Math.sin(this.angle);
      const toW = (lx, ly) => ({ x: c.x + lx * ca - ly * sa, y: c.y + lx * sa + ly * ca });
      if (d.t < .55) {
        const u = d.t / .55, e = u * u, p = toW(R * .1, -R * (2.6 - e * 2.5));
        x.save(); x.translate(p.x, p.y); x.rotate(this.angle + (1 - u) * 1.2);
        x.fillStyle = '#F4F4F2'; x.strokeStyle = '#14161B'; x.lineWidth = 2;
        x.beginPath(); x.roundRect(-R * .2, -R * .2, R * .4, R * .4, R * .06); x.fill(); x.stroke();
        x.beginPath(); x.moveTo(-R * .2, -R * .04); x.lineTo(R * .2, -R * .04); x.stroke();
        x.restore();
        if (u > .9 && !d.hit) { d.hit = true; for (const q of this.pts) q.vy += 1.2; }
      } else if (d.t < 2.4) {
        const u = (d.t - .55) / 1.85, sc = Math.min(1, u * 8) * (1 + Math.max(0, .15 - u) * 3), p = toW(R * .82, -R * .5);
        x.save(); x.globalAlpha = Math.min(1, (1 - u) * 4); x.translate(p.x, p.y - u * R * .3); x.scale(sc, sc);
        x.fillStyle = '#14161B'; x.beginPath(); x.arc(0, 0, R * .22, 0, TAU); x.fill();
        x.fillStyle = '#FFC94D'; x.font = `800 ${R * .22}px 'Hanken Grotesk',system-ui,sans-serif`; x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText('+1', 0, R * .01); x.restore();
      } else this.drop = null;
    }
    zzz(c, t) {
      const x = this.ctx, R = this.R;
      x.save(); x.fillStyle = this.P.body; x.font = `700 ${R * 0.32}px 'Hanken Grotesk',system-ui,sans-serif`;
      for (let i = 0; i < 3; i++) {
        const k = ((t * 0.5 + i / 3) % 1);
        x.globalAlpha = Math.sin(k * Math.PI);
        x.fillText('z', c.x + R * (0.7 + k * 0.6), c.y - R * (0.8 + k * 1.1));
      }
      x.restore();
    }
    bubble(c) {
      const x = this.ctx, b = this.state.bubble, R = this.R;
      const a = Math.min(1, b.t * 8, (b.life - b.t) * 5), pop = 1 + Math.max(0, 0.25 - b.t) * 1.2;
      x.save(); x.globalAlpha = Math.max(0, a);
      const fs = Math.max(13, R * 0.24);
      x.font = `600 ${fs}px 'Hanken Grotesk',system-ui,sans-serif`;
      const w = x.measureText(b.text).width + fs * 1.4, h = fs * 2;
      let bx = c.x - w / 2, by = c.y - R * 1.25 - h;
      if (by < 8) by = c.y + R * 1.1;
      bx = Math.max(8, Math.min(this.W - w - 8, bx));
      x.translate(bx + w / 2, by + h); x.scale(pop, pop); x.translate(-(bx + w / 2), -(by + h));
      b.rect = { x: bx, y: by, w, h };
      x.fillStyle = this.P.bub; x.beginPath(); x.roundRect(bx, by, w, h, h / 2); x.fill();
      x.beginPath(); const tx = Math.max(bx + h / 2, Math.min(bx + w - h / 2, c.x));
      if (by < c.y) { x.moveTo(tx - 6, by + h - 1); x.lineTo(tx, by + h + 7); x.lineTo(tx + 6, by + h - 1); } else { x.moveTo(tx - 6, by + 1); x.lineTo(tx, by - 7); x.lineTo(tx + 6, by + 1); }
      x.fill();
      x.fillStyle = this.P.bubInk; x.textBaseline = 'middle'; x.textAlign = 'center';
      x.fillText(b.text, bx + w / 2, by + h / 2 + 1);
      x.restore();
    }
  }
  customElements.define('ambiw-buddy', AmbiwBuddy);
})();
